import { fetchJson } from '../utils/fetchJson';

export async function getAuditLogs(params = {}) {
  const query = new URLSearchParams();
  if (params.from) query.set('from', params.from);
  if (params.to) query.set('to', params.to);
  if (params.action) query.set('action', params.action);
  if (params.schoolId) query.set('schoolId', params.schoolId);
  if (params.userType) query.set('userType', params.userType);
  const qs = query.toString();
  const data = await fetchJson(`/api/audit-trails${qs ? '?' + qs : ''}`);
  return { data: Array.isArray(data) ? data : (data?.rows || data?.logs || []) };
}
